import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ordersData: [],
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setOrdersData: (state, action) => {
      console.log("state", state, action);
      state.ordersData = action.payload;
    },
    resetFileUploads: () => initialState, // Reset just this slice
  },
});

export const { setOrdersData, resetFileUploads } = ordersSlice.actions;

const ordersSliceReducer = ordersSlice.reducer;

export default ordersSliceReducer;
